/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2018-3-23
 * @see https://github.com/yakitoritabetai/Leaflet.LabelTextCollision
 * @see https://github.com/XC-Zhang/leaflet-text
 */
L.Canvas.include({
  /**
   * 获取文本宽度
   */
  _getTextWidth(layer) {
    this._ctx.font = layer.options.font;
    return this._ctx.measureText(layer._text).width;
  },
  /**
   * 
   */
  _updateText(layer) {
    if (!this._drawing || layer._empty()) {
      return;
    }

    var p = layer._point;
    var ctx = this._ctx;
    var options = layer.options;

    if (!options.fill) {
      return;
    }

    this._drawnLayers[layer._leaflet_id] = layer;
    ctx.font = options.font;
    ctx.translate(p.x, p.y);
    ctx.rotate(options.rotation);
    ctx.fillStyle = options.color;
    ctx.textAlign = options.textAlign;
    ctx.fillText(layer._text, 0, 0);
    ctx.rotate(-options.rotation);
    ctx.translate(-p.x, -p.y);
  }
});
/**
 * 废弃 svg 的text渲染
 */
// L.SVG.include({
//   /**
//    * 
//    */
//   _getTextWidth: function (layer) {
//     return layer._path.getComputedTextLength();
//   },
//   /**
//    * 
//    */
//   _initPath: function (layer) {
//     var path;

//     if (L.Text && layer instanceof L.Text) {
//       path = layer._path = L.SVG.create("text");
//       path.textContent = layer._text;
//     } else {
//       path = layer._path = L.SVG.create("path");
//     }

//     if (layer.options.className) {
//       L.DomUtil.addClass(path, layer.options.className);
//     }

//     if (layer.options.interactive) {
//       L.DomUtil.addClass(path, 'leaflet-interactive');
//     }

//     this._updateStyle(layer);
//     this._layers[L.stamp(layer)] = layer;
//   },
//   /**
//    * 
//    */
//   _updateText: function (layer) {
//     let { options, _path: path, _point: p } = layer;
//     let { textAlign } = options;
//     //
//     path.setAttribute('x', p.x);
//     path.setAttribute('y', p.y);
//     path.setAttribute('transform', 'rotate(' + options.rotation / Math.PI * 180 + ' ' + p.x + ' ' + p.y + ')');
//     path.setAttribute('text-anchor', textAlign === 'center' ? 'middle' : textAlign);
//   }
// });
/**
 * 
 */
L.Text = L.Path.extend({
  options: {
    color: 'blue',
    fill: true,
    fillOpacity: 1.0,
    rotation: 0.0,
    stroke: false,
    textAlign: 'center',
    font: "14px arial"
  },
  /**
   * 
   */
  initialize: function (latlng, text, options) {
    L.setOptions(this, options);
    this._latlng = L.latLng(latlng);
    this._text = String(text || options.text);
  },

  getLatLng() {
    return this._latlng;
  },

  _project() {
    this._point = this._map.latLngToLayerPoint(this._latlng);
    this._updateBounds();
  },

  _updateBounds() {
    var w = this._renderer._getTextWidth(this);
    var p = [w / 2, w / 2];
    this._pxBounds = L.bounds(this._point.subtract(p), this._point.add(p));
  },

  _update() {
    if (this._map) {
      this._updatePath();
    }
  },

  _updatePath() {
    this._renderer._updateText(this);
  },

  _empty() {
    return !this._renderer._bounds.intersects(this._pxBounds);
  },

  _containsPoint: function (p) {
    return false;
  },
  /**
   * 
   */
  toGeoJSON() {
    let { lat, lng } = this.getLatLng();
    this.options.text = this._text;

    return {
      type: 'Feature',
      properties: {},
      geometry: { coordinates: [lng, lat], type: 'Text' }
    }
  }
});

L.text = function (latlng, text, options) {
  return new L.Text(latlng, text, options);
};


// WEBPACK FOOTER //
// ./src/marker/Text.js